import { render, staticRenderFns } from "./BlacklistSingleModal.vue?vue&type=template&id=b913a164"
import script from "./BlacklistSingleModal.vue?vue&type=script&lang=js"
export * from "./BlacklistSingleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports